<!-- *ngIf="isShown" -->
<div class="card reservation-cards card-with-no-padding">
    <div class="card-head pr-0">
        <div class="row w-100 padding-left align-items-center">
            <div class="col-10 pl-1">
                <div class="title font-24 fontSemiBold">{{'restaurant.Reservation Channels' | translate}}</div>
            </div>
            <div class="col-2 text-right pl-auto pr-0" *ngIf="canEdit">
                <button type="button" class="btn btn-with-icon-transparent" (click)="editReservationChannels()">
                    <mat-icon>edit</mat-icon>
                </button>
            </div>
        </div>

    </div>

    <div *ngIf='dataLoading' class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>
    <ng-container *ngIf='!dataLoading'>
        <div class="flex-container d-flex mt-2" *ngIf="selectedReservationChannels?.length; else dataEmpty">
            <ng-container *ngFor="let reservation of reservationChannels">
                <div class="card" *ngIf="reservation.isSelected == true">
                    <div class="row">
                        <div class="col-12">
                            <div [innerHTML]="reservation.icon | sanitizeHtml"></div>
                        </div>
                        <div class="col-12">
                            <p class="font-16 mt-2 mt-2">{{reservation.name}}</p>
                        </div>
                    </div>
                </div>
                <p *ngIf="(reservation.isOnlineReservation == true && reservation.isSelected == true && selectedReservationChannels?.length == 1)"
                    class="text-center grey-color font-16 d-block m-auto">{{"content4.Online Reservation is enabled" |
                    translate}}</p>
            </ng-container>

        </div>


        <ng-template #dataEmpty>
            <p class="text-center grey-color font-16">{{"restaurant.Reservation Channels not yet added" | translate}}</p>
        </ng-template>
    </ng-container>
</div>

<div class="card reservation-cards card-with-no-padding">
    <div class="card-head pr-0">
        <div class="row w-100 padding-left align-items-center">
            <div class="col-10 pl-1">
                <div class="title font-24 fontSemiBold">{{'profile.When the Guest can place an Order' | translate}}
                </div>
            </div>
            <div class="col-2 text-right pl-auto pr-0" *ngIf="canEditplaceOrderTime">
                <button type="button" class="btn btn-with-icon-transparent" (click)="editRestaurantConfig()">
                    <mat-icon>edit</mat-icon>
                </button>
            </div>
        </div>
    </div>
    <p class="info ml-3 mt-1">
        {{'profile.This rule is intended to avoid issues with the guests.' | translate }} <span class="fontLight italic">{{'profile.(so 6 hours or less is recommended)' | translate}}</span>
    </p>
    <p class="info ml-3 mt-3">
        {{'profile.The ordered items will be reserved from your inventory once the guest has placed his order' | translate }}
    </p>
    <div class="grey-list-items form-group">
        
        <div class="list-item pl-3 mt-1 mb-0 pb-0">
            <div class="d-flex align-items-center">
                <span class="font-16 fontMedium text-color">{{'profile.The guest can place his/her order' | translate }} </span> 
                <span class="font-16 ml-3 mr-3 fontSemiBold text-color">{{placeOrderTime || 1}}</span>
                <span class="font-16 fontMedium text-color">{{'profile.hours earlier to (before) the reservation time' | translate }} </span> 
            </div>
        </div>
    </div>
</div>